//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getRoomsByMemberId} from "../../../api/newOwner";

export default {
    name: "houses",
    data() {
        return {
            leftIco: require('@/assets/img/ico-building.png'),
            list: []
        }
    },
    methods: {
        getOwners() {
            let memberId = localStorage.getItem('MemberId');
            if (!memberId) {
                return
            }
            // abp.ajax.get('/api/services/app/Owner/GetOwnersByMemberId?memberId=' + parseInt(memberId)).then(res => {
            getRoomsByMemberId(parseInt(memberId)).then(res => {
                this.list = [];
                this.list.push(...res.data.result);
            }).finally(() => {
            });
        },

        getMyMember() {
            const vm=this;
            this.$store.dispatch({
                type: 'member/getMyMember'
            }).then(() => {
                vm.member = vm.$store.state.member.memberInfo;
                localStorage.setItem('MemberId', this.member.id);
                vm.getOwners();
            }).finally(() => {
                vm.$toast.clear();
            });
        },
        showDetail(row) {
            // :to="{path:'/houseCard/'+item.id}"
            this.$router.push({
                name: 'houseCard',
                params: {
                    id: row.roomOwnerId
                }
            })
        }
    },
    created() {
        this.getMyMember();
        // this.getOwners();
    }
}
